export enum ClientType {
    BUSINESS = 'Business',
    INDIVIDUAL = 'Individual'
}